var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33332 10.6664C1.26731 10.6666 1.20274 10.6471 1.14782 10.6104C1.09289 10.5738 1.05007 10.5217 1.0248 10.4607C0.999518 10.3998 0.992916 10.3326 1.00583 10.2679C1.01874 10.2032 1.05058 10.1437 1.09732 10.0971L5.52865 5.66644L1.09732 1.23577C1.03473 1.17318 0.999566 1.08829 0.999566 0.99977C0.999566 0.911253 1.03473 0.826361 1.09732 0.76377C1.15991 0.701179 1.2448 0.666016 1.33332 0.666016C1.42184 0.666016 1.50673 0.701179 1.56932 0.76377L6.23599 5.43044C6.26703 5.4614 6.29166 5.49818 6.30846 5.53868C6.32527 5.57918 6.33392 5.62259 6.33392 5.66644C6.33392 5.71028 6.32527 5.7537 6.30846 5.79419C6.29166 5.83469 6.26703 5.87147 6.23599 5.90244L1.56932 10.5691C1.53831 10.6 1.5015 10.6246 1.46101 10.6413C1.42051 10.658 1.37712 10.6665 1.33332 10.6664Z",
    fill: "#0276B1",
    stroke: "#0276B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/ChevronRight.b6dacaa2b270df4ae4e70a8290b15b51.svg";
export { ForwardRef as ReactComponent };